import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { putUser } from "store/thunks";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";

const CheckboxStatusUser = ({ item, isDisabled = false, triggerRefresh }: { item: any, isDisabled?: boolean, triggerRefresh?: any }) => {
  const { t, i18n } = useTranslation();

  const [itemActiveStatusUser, setItemActiveStatusUser] = useState<any>(null);

  const handleOnConfirmUpdate = async (item: {
    id: number | string;
    isActive: number | boolean;
  }) => {
    try {
      if (!item) return;

      const response: any = await putUser(item?.id, {
        account: {
          isActive: item?.isActive,
        },
      });

      if (response?.data) {
        triggerRefresh && triggerRefresh();

        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

//   useEffect(() => {
//     if (item) {
//       setItemActiveStatusUser({
//         isActive: item?.isActive,
//         id: item?.id,
//       });
//     }
//   }, [item]);

  return (
    <div
      className="form-check form-switch form-switch-sm text-center"
      dir="ltr"
      // style={{ width: 80 }}
    >
      <input
        type="checkbox"
        className="form-check-input"
        name="isActive"
        checked={itemActiveStatusUser ? itemActiveStatusUser?.isActive == true : item?.isActive == true}
        disabled={(isDisabled || item?.is_deleted === 1) ? true : false}
        onChange={(e) => {
          e?.preventDefault();
          const value = e?.target?.checked;
          handleOnConfirmUpdate({
            id: item?.id,
            isActive: e?.target?.checked,
          });
        }}
      />
      {
        item?.is_deleted === 1 && (
          <div>
            <small className="text-danger">{t('Deleted')}</small>
          </div>
        )
      }
    </div>
  );
};

export default CheckboxStatusUser;
